import { useContext } from "react";
import SentimentDrivers from "../SentimentDriver/SentimentDriver";
import MarketSummary from "./MarketSummary";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import classes from "./MarketOverview.module.css";
import { LLM_OPTIONS } from "../../../utils/constant";
import { filterKey } from "../BrandAudit";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";
import { OVERVIEW_LLM_LABELS } from "../../../utils/constant"
import DashboardCheckbox from "../SelectedComponent/DashboardCheckbox";

export default function BrandOverview() {
  const discoveryCtx = useContext(DiscoveryContext);
  const id = "Sentiment_Drivers";
  const { checked, uniqueKey } = useIsSelectedSection({
    id,
    tab: tab.marketOverview,
  });

  return (
    <>
      <div className={classes.containerWrapper}>
        {discoveryCtx.state.showReportCheckbox && (
            <DashboardCheckbox
              dashboardTab={tab.marketOverview}
              dashboardName={`Market Overview`}
            />
          )}
        <MarketSummary />
        <div className={classes.headerWrapper}>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <h5 className={classes.heading}>{discoveryCtx?.mapMetricTitle?.("Sentiment Drivers") ?? "Sentiment Drivers"}</h5>
            {discoveryCtx.state.showReportCheckbox && (
              <Checkbox
                checked={checked}
                onChange={() => {
                  discoveryCtx?.clickComponentCheckbox({
                    uniqueKey,
                    filter: {
                      id: id,
                      title: discoveryCtx?.mapMetricTitle?.("Sentiment Drivers") ?? "Sentiment Drivers",
                      tab: tab.marketOverview,
                      uniqueKey,
                    },
                    checked,
                  });
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            )}
          </div>
          <div className={classes.dropdownWrapper}>
            <MUISelect
              fullWidth={false}
              optionValue={discoveryCtx.state.selectedLLM}
              label={"LLM"}
              id={filterKey.llm}
              options={(discoveryCtx.llm || []).map((llm) => {
                const match = OVERVIEW_LLM_LABELS[llm]
                return {
                  name: match ? match : llm,
                  value: llm,
                };
              })}
              onChange={(e) => {
                discoveryCtx.updateSelectedLLM(e.target.value);
              }}
            />
            <MUISelect
              fullWidth={false}
              optionValue={discoveryCtx.state.selectedMarket}
              label={"Market"}
              id={filterKey.market}
              options={(discoveryCtx?.markets || []).map((market) => {
                return {
                  name: market,
                  value: market,
                };
              })}
              onChange={(e) => {
                discoveryCtx.updateSelectedMarket(e.target.value);
              }}
            />
          </div>
        </div>
        <SentimentDrivers isSelectedMarket={true} />
      </div>
    </>
  );
}
